import * as React from "react";
import { useEffect, useState } from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { useSelector } from "react-redux";
import StocksReportsScreen from "../../../screens/Reports/StocksReportScreens/StocksReportScreen";
import SalesScorecardScreen from "../../../screens/Reports/SalesScorecardScreens/SalesScorecardScreen";
import UsageSalesScorecardScreen from "../../../screens/Reports/UsageSalesScorecardScreens/UsageSalesScorecardScreen";
import ValueSalesScorecardScreen from "../../../screens/Reports/ValueSalesScorecardScreens/ValueSalesScorecardScreen";
import InvoiceDNDetailScreen from "../../../screens/Reports/InvoiceDNDetailScreens/InvoiceDNDetailScreen";
import PrdouctsReportsScreen from "../../../screens/Reports/ProductsReportScreens/ProductsReportScreen";
import CustomerStatusReportsScreen from "../../../screens/Reports/CustomerStatusReportScreens/CustomerStatusReportScreen";
import { drawerItemsMain } from "./ReportsDrawerItemsMain";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import DynamicWidthScreen from "../../../screens/NotUsed/DynamicWidthScreen";
import StockReportDetailsReportScreen from "../../../screens/Reports/StocksReportScreens/StockReportDetailsReport";
import CustomerStatusDetailReportScreen from "../../../screens/Reports/CustomerStatusReportScreens/CustomerStatusDetailReportScreen";
import { useTranslation } from "../../../utils/useTranslation";
import { userClaimInformation } from "../../../models/usersModel";
import teamConfig from "../../../utils/constants/teams";
import rolesConfig from "../../../utils/constants/roles";
const Drawer = createDrawerNavigator();

export default function ReportsDrawerNavigator() {
  const { t } = useTranslation();
  const dimensions = useWindowDimensions();
  const [userProfile, setUserProfile] = useState<userClaimInformation>();
  const { userInfo, currentRole } = useSelector(
    (state: any) => state.configurations,
  );
  const { salesManager } = teamConfig.teams;
  const isAdminOrOwner = [
    rolesConfig.roles.admin,
    rolesConfig.roles.owner,
  ].includes(currentRole?.toUpperCase());

  useEffect(() => {
    setUserProfile(userInfo);
  }, [userInfo]);
  return (
    <Drawer.Navigator
      initialRouteName="Home"
      screenOptions={{
        drawerStyle: {
          width: 180,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
      }}
      drawerContent={(props) => (
        <CustomDrawerContent
          drawerItems={drawerItemsMain(
            userProfile?.team.toUpperCase() ?? "",
            isAdminOrOwner,
          )}
          {...props}
        />
      )}
    >
      <Drawer.Screen
        name="Stocks"
        component={StocksReportsScreen}
        options={{ title: t("stock") }}
      />
      <Drawer.Screen
        name="Products"
        component={PrdouctsReportsScreen}
        options={{ title: t("searchProduct") }}
      />
      <Drawer.Screen
        name="CustomerStatus"
        component={CustomerStatusReportsScreen}
        options={{ title: t("customerStatus") }}
      />
      <Drawer.Screen
        name="CustomerStatusDetailReportScreen"
        component={CustomerStatusDetailReportScreen}
        options={{ title: t("customerStatusDetails") }}
      />
      {process.env.NODE_ENV !== "production" && (
        <Drawer.Screen
          name="DynamicWidth"
          component={DynamicWidthScreen}
          options={{ title: t("dynamicWidthScreen") }}
        />
      )}

      <Drawer.Screen
        options={{
          drawerLabel: "StockReportDetailsReportScreen",
          title: t("stockReportDetails"),
        }}
        name="StockReportDetailsReportScreen"
        component={StockReportDetailsReportScreen}
      />
      {(userProfile?.team.toUpperCase() === salesManager || isAdminOrOwner) && (
        <>
          {
            <>
              <Drawer.Screen
                name="SalesScorecard"
                component={SalesScorecardScreen}
                options={{ title: t("salesScorecardTitle") || "Sales Scorecard - Year On Year Usage" }}
              />
              <Drawer.Screen
                name="UsageSalesScorecard"
                component={UsageSalesScorecardScreen}
                options={{ title: t("usageSalesScorecardTitle") || "Usage Sales Scorecard — Monthly Usage" }}
              />
              <Drawer.Screen
                name="ValueSalesScorecard"
                component={ValueSalesScorecardScreen}
                options={{ title: t("valueSalesScorecardTitle") || "Value Sales Scorecard — Monthly Value" }}
              />
              <Drawer.Screen
                name="InvoiceDNDetail"
                component={InvoiceDNDetailScreen}
                options={{ title: t("invoiceDNDetail") }}
              />
            </>
          }
        </>
      )}
    </Drawer.Navigator>
  );
}
